<template>
    <div :class="{'whitelabel': this.$features.WHITELABEL}">
        <div class="row loader" :class="{'visible': !challengeGroupRequest.loaded}">
            <p>
                <span class="loading-spinner loading-spinner-big loading-spinner-green"></span>
                <span class="sr-only">Loading...</span>
            </p>
        </div>
        <ErrorComponent v-if="challengeGroupRequest.error" message="Die Challengegruppe konnte nicht geladen werden"
                        icon="dev-search"
                        style="text-align: center; margin-top: 20px"> Leider ist beim Laden der Daten ein
            Fehler aufgetreten. Sollte der Fehler auch nach einem Neuladen der Seite weiterhin bestehen,
            kontaktiere uns bitte auf Twitter oder schreibe an den EntwicklerHelden Support: <a
                href="mailto:hallo@entwicklerheld.de">hallo@entwicklerheld.de</a>
        </ErrorComponent>
        <div v-if="challengeGroupRequest.loaded && !challengeGroupRequest.error" :class="{'whitelabel-challenge-container': this.$features.WHITELABEL}">
            <UserCoinsOverlay v-if="!this.$features.WHITELABEL" ref="userCoinsOverlay" style="display: none;"/>
            <OnMobileComponent :isVisible="onMobileModalVisible" :closeHandler="closeOnMobileModal"
                               @jumpToNextTask="jumpToNextTask"/>
            <MetaDataComponent
                :title="challengeGroupData.title + ' ' + getTechnologyDisplayNameJustLanguage(selectedTechnology) + ' Challenge - EntwicklerHeld.de'"
                :url="this.$route.fullPath"/>

            <div class="row challenge-title">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                    <h1 class="page-header">
                        <span class="challenge-icon">
                          <img :src="challengeGroupData.image"
                               :alt="'An icon for the ' + challengeGroupData.title + ' challenge'">
                        </span>
                        {{ challengeGroupData.title }}
                        <span class="difficulty-level">
                            <img
                                :src="'https://res.cloudinary.com/dspi5zyaa/image/upload/v1638971079/eh-platform/icons/difficulties/' + difficulties[challengeGroupData.complexity - 1].icon + '.svg'"
                                alt="difficulty-level">
                        </span>
                    </h1>
                </div>
                <div v-if="challengeGroupTechnologies.length > 6" class="col-xs-12 hidden-md hidden-sm hidden-xs dropdown-container">
                    <LanguageDropDown :challenge-group-technologies="challengeGroupTechnologies" v-model="selectedChallengeId"/>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 lang-selector hidden-xs hidden-sm"
                     :class="{'hidden-md': challengeGroupTechnologies.length > 5, 'hidden-lg': challengeGroupTechnologies.length > 6 }">
                    <div class="tabs-container">
                        <div class="tabs">
                            <div v-for="(technology, index) in challengeGroupTechnologies">
                                <input v-model="selectedChallengeId" :value="technology.challengeId" type="radio"
                                       :id="'radio'+ index+1" name="tabs"/>
                                <label class="tab" :for="'radio'+ index+1">
                                    <i v-if="technology.isSolved" class="challenge-state-icon dev-check"></i>
                                    {{ getTechnologyDisplayNameShort(technology).toUpperCase() }}
                                </label>
                            </div>
                            <span class="glider"
                                  v-bind:style="{transform: 'translateX('+ selectedTechnologyIndex*100 +'%)'}"
                                  :class="getLanguageBubbleCSS(selectedTechnology)">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <WhiteLabelBannerComponent v-if="this.$features.WHITELABEL"/>
            <div class="row">
                <div class="col-xs-12 col-sm-12 visible-xs visible-sm"
                     :class="{'visible-md': challengeGroupTechnologies.length > 5 }">
                    <div class="language-slider-container">
                        <span v-if="challengeGroupTechnologies.length > 1" @click="siemaSlider.prev()"
                              class="nav-prev nav-icon" aria-hidden="true"><i class="dev-chevron-left"></i></span>
                        <span v-if="challengeGroupTechnologies.length > 1" @click="siemaSlider.next()"
                              class="nav-next nav-icon" aria-hidden="true"><i class="dev-chevron-right"></i></span>
                        <div class="active-background"
                             :class="getLanguageBubbleCSS(selectedTechnology)"></div>
                        <div class="siema language-slider" ref="languageSlider">
                            <div v-for="technology in challengeGroupTechnologies" class="text-center language-item">
                                <span class="language-slider-tab">{{
                                        getTechnologyDisplayNameShort(technology).toUpperCase()
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="challengeGroupTechnologies.length > 1" class="dots">
                        <span v-for="(technology, index) in challengeGroupTechnologies" class="dot"
                              :class="{'active-dot': technology.challengeId === selectedChallengeId}"
                              @click="siemaSlider.goTo(index)"></span>
                    </div>
                </div>
            </div>
            <ErrorComponent v-if="flowRequest.error" message="Testbeschreibung konnte nicht geladen werden"
                            icon="dev-search"
                            style="text-align: center; margin-top: 20px"> Leider ist beim Laden der Daten ein
                Fehler aufgetreten. Sollte der Fehler auch nach einem Neuladen der Seite weiterhin bestehen,
                kontaktiere uns bitte auf Twitter oder schreibe an den EntwicklerHelden Support: <a
                    href="mailto:hallo@entwicklerheld.de">hallo@entwicklerheld.de</a>
            </ErrorComponent>

            <ErrorComponent v-if="campaignRequest.error" message="Einzelne Challenges konnten nicht geladen werden"
                            icon="dev-search"
                            style="text-align: center; margin-top: 20px"> Leider ist beim Laden der Daten ein
                Fehler aufgetreten. Sollte der Fehler auch nach einem Neuladen der Seite weiterhin bestehen,
                kontaktiere uns bitte auf Twitter oder schreibe an den EntwicklerHelden Support: <a
                    href="mailto:hallo@entwicklerheld.de">hallo@entwicklerheld.de</a>
            </ErrorComponent>
            <transition name="fade">
                <div v-if="!campaignRequest.error && campaignRequest.loaded">
                    <div class="row challenge-details panel" v-if=" !this.$features.WHITELABEL">
                        <div class="bg-object-container animated bounceInLeft"></div>
                        <div class="col-xs-12 col-sm-7">
                            <div class="row">
                                <div class="col-sm-10 details-content">
                                    <div class="">
                                        <h4 class="summary">Summary</h4>
                                        <div id="challenge-description" class="challenge-description">
                                            <div class="challenge-description-detail"
                                                 v-html="challengeGroupData.descriptionDetail"></div>
                                            <div class="reward-panel clearfix"
                                                 :class="{rewardChosen: campaignRequest.challenge_data.selectedReward !== null}">
                                                <h4 class="summary">
                                                    Belohnung
                                                </h4>
                                                <p v-if="!campaignRequest.challenge_data.solved">
                                                    Diese <strong>Coins</strong> bekommst du bei Challenge Abgabe:
                                                </p>
                                                <p v-if="campaignRequest.challenge_data.solved">
                                                    Diese <strong>Coins</strong> hast du erhalten:
                                                </p>

                                                <div class="reward-box-container no-border">
                                                    <div class="reward-box" data-toggle="tooltip"
                                                         data-placement="bottom"
                                                         :title="
                                                            campaignRequest.challenge_data.solved ?
                                                            'Diese Belohnung hast du erhalten. Deine Lösung kann anonymisiert eingesehen werden.' :
                                                            'Diese Belohnung erhältst du, wenn du die Challenge gelöst hast. Deine Lösung kann anonymisiert eingesehen werden.'
                                                        ">
                                                        <div class="reward-svg-box">
                                                            <img
                                                                src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1611131281/eh-platform/icons/smashicons_super_heroes_hero-outfit-icon-23-retro.svg"
                                                                alt="An icon with a hero" class="sponsored-icon"/>
                                                        </div>
                                                        <p class="text-right coins-icon-paragraph">
                                                            {{ rewardAmount }}
                                                            <img src="/assets/icons/coins.svg" alt="An icon with coins"
                                                                 class="coins-icon"/>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div style="clear:both;">
                                                    <p v-if="!campaignRequest.challenge_data.solved">
                                                        Du bekommst außerdem bei Challenge Abgabe:
                                                    </p>
                                                    <p v-if="campaignRequest.challenge_data.solved">
                                                        Außerdem hast du erhalten:
                                                    </p>
                                                    <div class="reward-box-container no-border">
                                                        <div class="reward-box" data-toggle="tooltip"
                                                             data-placement="bottom"
                                                             :title="'Du bekommst für viele Aktionen Erfahrungspunkte und steigst Level auf.'">
                                                            <div class="reward-svg-box">
                                                                <img src="/assets/icons/EXP-icon.svg"
                                                                     alt="An icon for experience points"
                                                                     class="sponsored-icon"/>
                                                            </div>
                                                            <p class="text-right coins-icon-paragraph">
                                                                {{
                                                                    campaignRequest.challenge_data.tasks.length * 50 +
                                                                    300
                                                                }}
                                                                <strong>XP</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="sponsoringInformationDetailsRequest.loaded && sponsoringInformationDetailsRequest.apiData.type === 'SPONSORED'">
                                            <h4 class="summary">Sponsor</h4>
                                            <div class="contact-information reward-box">
                                                <p>Diese Challenge ist durch
                                                    {{ sponsoringInformationDetailsRequest.apiData.name }} gesponsert.
                                                    Löst du die Challenge, werden dir von
                                                    diesem Unternehmen spannende Jobangebote angezeigt. Das Unternehmen
                                                    kann deine Challenge-Lösung anschauen
                                                    und dich im Anschluss im Chat unverbindlich kontaktieren. Du bleibst
                                                    dabei weiterhin anonym und entscheidest selbst, wie es
                                                    weitergeht.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-lg-5 col-sm-5 pull-right sponsor-wrapper">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div v-if="isSponsored" class="sponsor-container">
                                        <SponsoringDetails :sponsoringRequest="sponsoringInformationDetailsRequest"/>
                                    </div>
                                    <div v-if="isPool"
                                         class="animated fadeIn delay-2s interact-container">
                                        <div class="panel  no-sponsor-panel">
                                            <div class="panel-body interact-panel">
                                                <ResultInteract
                                                    :challenge="campaignRequest.challenge_data"></ResultInteract>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ChallengeOfTheWeek v-if="isChallengeOftheWeek" :user-profile-request="userProfileRequest"
                                        :bannerOnly="true"></ChallengeOfTheWeek>
                    <ul class="nav nav-tabs" v-if=" !this.$features.WHITELABEL">
                        <li :class="{active: view === 'overview'}"><a href="#" @click.prevent="setView('overview')">Übersicht</a>
                        </li>
                        <li :class="{active: view === 'yourSolution'}"><a href="#"
                                                                          @click.prevent="setView('yourSolution')">Deine
                            Lösung</a></li>
                        <li :class="{active: view === 'otherSolutions'}"><a href="#"
                                                                            @click.prevent="setView('otherSolutions')">Andere
                            Lösungen</a></li>
                    </ul>
                    <div class="container-fluid tab-container" >
                        <div v-if="view==='overview'">
                            <div class="row row-flex statistics-row" v-if=" !this.$features.WHITELABEL">
                                <SubmissionStatistics
                                    :key="submissionsComponentKey"
                                    :challenge-id="campaignRequest.challenge_data.id">
                                </SubmissionStatistics>
                            </div>
                            <div
                                v-if="campaignRequest.challenge_data.solved && isAuthenticated && isSponsored && isAcceptedAsSponsored"
                                class="row">
                            </div>
                            <div v-if="campaignRequest.challenge_data.tasks.length > 1" class="row challenge-tasks">
                                <div class="progressbar">
                                    <ul class="nav nav-tabs nav-stages">
                                        <li
                                            v-for="(stage, index) in campaignRequest.challenge_data.tasks"
                                            v-bind:style="{ width: 100/campaignRequest.challenge_data.tasks.length + '%'}"
                                            data-toggle="tab"
                                            :class="{'active': stage.task_id === currentTaskId, 'solved': stage.solved === true}"
                                            v-on:click="setTaskIdWithIndex(index)">
                                            <a>Stage {{ (index + 1) }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row loader" :class="{'visible': !flowRequest.loaded}">
                                <p class="text-center">
                                    <span class="loading-spinner loading-spinner-big loading-spinner-green"></span>
                                    <span class="sr-only">Loading...</span>
                                </p>
                            </div>
                            <div v-if="flowRequest.flow_data !== null && flowRequest.loaded" class="row flow">
                                <div class="col-sm-12">
                                    <div class="tab-content">
                                        <div class="row">
                                            <div class="col-xs-12 col-sm-3">
                                                <div class="panel">
                                                    <div class="panel-heading">
                                                        <h3 class="panel-title">Navigation</h3>
                                                    </div>
                                                    <div class="panel-body">
                                                        <hr/>
                                                        <p v-for="(scenario, scencario_index) in flowRequest.flow_data.scenarios">
                                                            <a :href="'#' + scenarioJumpLink(getStageByTaskId(currentTaskId), scencario_index)">{{ scenario.title }}</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-9">
                                                <div class="row">
                                                    <div class="col-xs-12 campaign-detail-flow-scenarios"
                                                         v-if="flowRequest.flow_data.scenarios.length !== 0">
                                                        <div class="panel flow-background">
                                                            <div class="panel-heading green-heading">
                                                                <h3 class="panel-title"><strong>Objective</strong></h3>
                                                            </div>
                                                            <div class="panel-body flow-body"
                                                                 v-html="getStageByTaskId(currentTaskId).description">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="flow-col col-lg-12">
                                                        <div class="panel"
                                                             v-for="(scenario, scencario_index) in flowRequest.flow_data.scenarios"
                                                             :class="{'green-test': inList(successfulScenarios, scenario), 'red-test': inList(failedScenarios, scenario)}">
                                                            <div class="panel-heading"
                                                                 :id="scenarioJumpLink(getStageByTaskId(currentTaskId), scencario_index)">
                                                                <h3 class="panel-title">
                                                                    <strong>Scenario
                                                                        {{ scencario_index + 1 }}: </strong>{{ scenario.title }}
                                                                </h3>
                                                                <p class="scenario-description"
                                                                   v-html="scenario.description"></p>
                                                                <hr class="scenario-hr">
                                                            </div>
                                                            <div class="panel-body scenario-body">
                                                                <div v-html="scenario.test"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="view==='yourSolution'">
                            <div v-if="isAuthenticated" class="solution-row">
                                <div
                                    v-if="campaignRequest.challenge_data.solved && challengeSolutions.loaded && !challengeSolutions.error">
                                    <div class="row animated fadeIn">
                                        <div class="col-xs-12">
                                            <div class="panel flow-background">
                                                <div class="panel-heading green-heading">
                                                    <h3 class="panel-title"><strong>Rank The Code</strong></h3>
                                                </div>
                                                <div class="panel-body flow-body">
                                                    <p>In Rank the Code kannst du Lösungen von anderen EntwicklerHeldys
                                                        betrachten, kommentieren
                                                        & bewerten. Natürlich kannst du nur Lösungen von Challenges
                                                        bewerten, die du selber schon
                                                        gemeistert hast. So kannst du die Lösung besser beurteilen und
                                                        deine Erfahrungen mit anderen
                                                        teilen. Hier siehst du deine Lösung und wie andere
                                                        EntwicklerHeldys darüber denken.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row animated fadeIn">
                                        <div class="col-xs-12 col-sm-6 col-md-4 animated fadeIn">
                                            <div class="date-solved-container">
                                                <div class="icon-container">
                                                </div>
                                                <div class="date-text clearfix">
                                                    <div class="date-container">
                                                        <strong>
                                                            Gelöst am
                                                        </strong>
                                                        <br/>
                                                        <span class="date"> {{
                                                                getNiceTime(challengeSolutions.apiData[0].timeSolved)
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="campaignRequest.challenge_data.tasks.length > 1" class="row">
                                        <ul class="nav nav-tabs stage-tabs">
                                            <li
                                                v-for="(stage, index) in campaignRequest.challenge_data.tasks"
                                                data-toggle="tab"
                                                :class="{'active': stage.task_id === currentTaskId}">
                                                <a href="#" @click.prevent="setTaskIdWithIndex(index)">Stage
                                                    {{ (index + 1) }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="campaignRequest.challenge_data.solved" class="row animated">
                                        <div class="col-xs-12 col-md-8 solution-col">
                                            <div class="panel flow-background">
                                                <div class="panel-body">
                                                    <div>
                                                        <extended-solution-editor-component
                                                            ref="extendedSolutionEditorComponent"
                                                            :solutionId="solutionId"
                                                            :language="campaignRequest.challenge_data.technology.language.toLowerCase()"
                                                            @userHasSolvedThisChallenge="setUserHasSolvedThisChallenge">
                                                        </extended-solution-editor-component>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-4 ratings-col">
                                            <solution-ratings-component
                                                ref="solutionRatingComponent"
                                                :solutionId="solutionId"
                                            ></solution-ratings-component>
                                            <code-comments-component
                                                @highlightCodeComment="highlightCodeComment"
                                                @unHighlightCodeComment="removeHighlightCodeComment"
                                                ref="codeCommentsComponent"
                                                :solutionId="solutionId">
                                            </code-comments-component>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!campaignRequest.challenge_data.solved" class="row">
                                    <div class="flex animated fadeIn">
                                        <img class="icon"
                                             src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1640083023/eh-platform/icons/smashicons_programming_and_coding_js-code-snippet-icon-72-cartoony.svg">
                                        <span>Hier wird deine Lösung angezeigt, wenn du die Challenge abgegeben hast.</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isAuthenticated">
                                <div class="row solution-row">
                                    <div class="flex animated fadeIn">
                                        <img class="icon"
                                             src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1640083023/eh-platform/icons/smashicons_programming_and_coding_js-code-snippet-icon-72-cartoony.svg">
                                        <span>Hier wird deine Lösung angezeigt, wenn du die Challenge abgegeben hast. Melde dich an, um zu erfahren, ob du die Challenge schon gelöst hast!</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="view==='otherSolutions'">

                            <div v-if="isAuthenticated" class="row solution-row">
                                <div v-if="!campaignRequest.challenge_data.solved">
                                    <div class="flex animated fadeIn">
                                        <img class="icon"
                                             src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1640083023/eh-platform/icons/smashicons_programming_and_coding_js-code-snippet-icon-72-cartoony.svg">
                                        <span>Hier werden Lösungen anderer EntwicklerHelden angezeigt, wenn du die Challenge abgegeben hast. Du kannst ihre Lösungen dann bewerten und kommentieren.</span>
                                    </div>
                                </div>
                                <other-solutions-tab-component
                                    v-if="campaignRequest.challenge_data.solved && currentTaskId"
                                    :challenge-data="campaignRequest.challenge_data"
                                    :task-id="currentTaskId"
                                    :not-blocked-task-ids="notBlockedTaskIdsForRTC"
                                    v-on:newCurrentTaskId="setTask"
                                >
                                </other-solutions-tab-component>
                            </div>
                            <div v-if="!isAuthenticated" class="row solution-row">
                                <div class="flex animated fadeIn">
                                    <img class="icon"
                                         src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1640083023/eh-platform/icons/smashicons_programming_and_coding_js-code-snippet-icon-72-cartoony.svg">
                                    <span>Hier werden Lösungen anderer EntwicklerHelden angezeigt, wenn du die Challenge abgegeben hast. Melde dich an, um zu erfahren, ob du die Challenge schon gelöst hast!</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="row flow" v-if="flowRequest.flow_data !== null && flowRequest.loaded">
                            <div class="panel start-challenge-panel animated fadeInUp"
                                 v-if="$features.WHITELABEL && campaignRequest.challenge_data.solved && userProfileRequest.loaded && !userProfileRequest.error">
                                <div
                                    class="solved-whitelabel-challenge">
                                    <div>Du hast die Challenge unter dem anonymen Namen
                                        <strong>{{ anonymizedName }}</strong> gelöst <i class="fa fa-check-circle"></i>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!campaignRequest.challenge_data.solved"
                                 class="panel start-challenge-panel animated fadeInUp">
                                <div class="challenge-button-container">
                                    <div class="action-button-wrapper">
                                        <div v-for="(button, buttonLabel) in campaignRequest.challenge_data.actions">
                                            <div v-if="buttonLabel === 'start' && testStatusRequest.loaded"
                                                 class="button-background">
                                                <button v-on:click="buttonAction(button.api_url, buttonLabel)"
                                                        class="btn btn-big-cta">
                                                    <i class="dev-play"></i>
                                                    <span class="hidden-xs"> Fortsetzen</span>
                                                    <span class="visible-xs-inline"> Fortsetzen</span>
                                                </button>
                                                <div v-if="buttonLabel !== 'login' && buttonLabel !== 'submit'"
                                                     class="language-label">
                                                    {{ getTechnologyDisplayNameJustLanguage(selectedTechnology) }}
                                                    <div class="technology-label">
                                                        {{ getTechnologyDisplayNameJustTechnology(selectedTechnology) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else-if="buttonLabel === 'accept'" class="button-background">
                                                <button v-on:click="acceptCampaign()"
                                                        class="btn btn-big-cta"
                                                        :disabled="!sponsoringInformationDetailsRequest.loaded && isAuthenticated">
                                                    <i class="dev-play"></i>
                                                    <span class="hidden-xs"> Starten</span>
                                                    <span class="visible-xs-inline"> Starten</span>

                                                </button>

                                                <div v-if="buttonLabel !== 'login' && buttonLabel !== 'submit'"
                                                     class="language-label">
                                                    {{ getTechnologyDisplayNameJustLanguage(selectedTechnology) }}
                                                    <div class="technology-label">
                                                        {{ getTechnologyDisplayNameJustTechnology(selectedTechnology) }}
                                                    </div>
                                                </div>

                                            </div>

                                            <div v-else-if="buttonLabel === 'select_reward'" class="button-background">
                                                <button v-on:click="acceptCampaign()"
                                                        class="btn btn-big-cta"
                                                        :disabled="!sponsoringInformationDetailsRequest.loaded && isAuthenticated">
                                                    Starten
                                                </button>
                                                <div v-if="buttonLabel !== 'login' && buttonLabel !== 'submit'"
                                                     class="language-label">
                                                    {{ getTechnologyDisplayNameJustLanguage(selectedTechnology) }}
                                                    <div class="technology-label">
                                                        {{ getTechnologyDisplayNameJustTechnology(selectedTechnology) }}
                                                    </div>
                                                </div>
                                            </div>

                                            <button v-if="buttonLabel === 'submit'"
                                                    v-on:click="receiveRewardDialogVisible = true"
                                                    class="btn btn-big-cta button-submit">
                                                <i class="dev-circle-check"></i> Challenge abgeben
                                            </button>
                                            <button v-else-if="buttonLabel === 'login'"
                                                    v-on:click="buttonAction(button.api_url, buttonLabel)"
                                                    class="btn button-login btn-big-cta">
                                                Login
                                            </button>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </transition>

            <ReceiveRewardComponent v-if="isAuthenticated && sponsoringInformationDetailsRequest.loaded"
                                    :isVisible="receiveRewardDialogVisible"
                                    :challenge="campaignRequest.challenge_data"
                                    :isSponsored="isSponsored"
                                    :sponsoringData="sponsoringInformationDetailsRequest.apiData"
                                    :additionalReward="(campaignRequest.challenge_data.selectedReward === null && isPool) || campaignRequest.challenge_data.selectedReward === 'WITHOUT_SPONSORING_AFTER_CONTACT'"
                                    :rewardSponsored="sponsoringInformationDetailsRequest.apiData.reward"
                                    :rewardDefault="campaignRequest.challenge_data.rewardDefault"
                                    :rewardInteract="campaignRequest.challenge_data.rewardInteract"
                                    :companySlug="sponsoringInformationDetailsRequest.apiData.companySlug"
                                    :twitterHandle="sponsoringInformationDetailsRequest.apiData.twitterHandle"
                                    :closeHandler="closeReceiveRewardDialog"
                                    :selectedReward="campaignRequest.challenge_data.selectedReward"
                                    :acceptHandler="acceptCampaign">
            </ReceiveRewardComponent>
        </div>
    </div>
</template>

<script>
import {services, eventBus} from "../main"
import {mapState} from 'vuex';
import OnMobileComponent from '../components/OnMobileComponent.vue';
import UserCoinsOverlay from "../components/rewards/UserCoinsOverlay.vue";
import ErrorComponent from "../components/ErrorComponent";
import QualityEditor from "../components/workspace/QualityEditor";
import ReceiveRewardComponent from "../components/campaigns/ReceiveRewardComponent";
import SubmissionStatistics from "../components/gamification/SubmissionStatistics";
import ResultInteract from "../components/interacts/ResultInteract";
import {isEmpty} from 'lodash';
import Siema from 'siema';
import {DIFFICULTIES, LANGUAGES} from "../const";
import {getTechnologyQuery} from "../services/Utilities";
import SolutionRatingsComponent from "../components/rank-the-code/SolutionRatingsComponent";
import YourSolutionTabComponent from "../components/campaigns/YourSolutionTabComponent";
import CodeCommentsComponent from "../components/rank-the-code/CodeCommentsComponent";
import ExtendedSolutionEditorComponent from "../components/rank-the-code/ExtendedSolutionEditorComponent";
import OtherSolutionsTabComponent from "../components/campaigns/OtherSolutionsTabComponent";
import mermaid from "mermaid";
import moment from "moment";
import ChallengeOfTheWeek from "../components/campaigns/ChallengeOfTheWeek";
import SponsoringDetails from "../components/company/SponsoringDetails";
import LanguageDropDown from "../components/campaigns/LanguageDropDown.vue";
import WhiteLabelBannerComponent from "../components/WhiteLabelBannerComponent.vue";


export default {
    name: "campaign-details",
    components: {
        WhiteLabelBannerComponent,
        LanguageDropDown,
        SolutionRatingsComponent,
        ResultInteract,
        ErrorComponent,
        OnMobileComponent,
        UserCoinsOverlay,
        QualityEditor,
        ReceiveRewardComponent,
        SubmissionStatistics,
        YourSolutionTabComponent,
        CodeCommentsComponent,
        ExtendedSolutionEditorComponent,
        OtherSolutionsTabComponent,
        ChallengeOfTheWeek,
        SponsoringDetails,
    },
    data() {
        return {
            campaignRequest: {loaded: false, error: null},
            challengeGroupRequest: {loaded: false, error: null},
            selectedChallengeId: "",
            sponsoringInformationDetailsRequest: {loaded: false, error: null},
            userProfileRequest: {loaded: false, error: null},
            flowRequest: {loaded: false, error: null},
            testStatusRequest: {loaded: false, error: null},
            submitChallengeRequest: {loaded: false, error: null},
            acceptChallengeRequest: {loaded: false, error: null},
            currentTaskId: null,
            selectedTaskId: this.$route.query.taskId || "",
            successfulScenarios: [],
            failedScenarios: [],
            loadTestStatusError: null,
            receiveRewardDialogVisible: false,
            onMobileModalVisible: false,
            versions: [],
            versionIndex: 0,
            currentVersionCode: "",
            previousVersionCode: "",
            step: 1,
            speed: 100,
            isPlaying: false,
            submissionsComponentKey: 0,
            siemaSlider: null,
            difficulties: DIFFICULTIES,
            forceRerenderSiemaSliderTimeout: null,
            includeDeactivated: this.$route.query.includeDeactivated !== undefined || window.INCLUDE_DEACTIVATED,
            view: this.$route.query.view || 'overview',
            userHasSolvedThisChallenge: false,
            challengeSolutions: [],
            notBlockedTaskIdsForRTC: [],
        }
    },
    props: {
        challengeGroup: {
            type: [Object],
            default() {
                return {}
            }
        }
    },
    watch: {
        'flowRequest.loaded': function () {
            if (this.flowRequest.loaded) {
                this.renderMermaid();
            }

        },
        isAuthenticated: function () {
            this.userProfileRequest = services.userService.getUserProfile();
            this.getChallengeGroupDetails();
            this.forceRerender();
        },
        '$route.params.slug': function () {
            this.getChallengeGroupDetails();
            this.forceRerender();
        },
        'currentTaskId': function () {
            this.flowRequest = services.flowService.getFlowContent(this.currentTaskId);
            if (this.isAuthenticated) {
                this.testStatusRequest = services.flowService.getTestStatus(this.currentTaskId);
                if (this.campaignRequest.challenge_data.solved) {
                    this.challengeSolutions = services.rankTheCodeService.getSolutionsForChallenge(this.selectedChallengeId);
                }
            }

        },
        'challengeSolutions.loaded': function () {
            if (this.challengeSolutions.apiData.length > 0) {
                for (let solution of this.challengeSolutions.apiData) {
                    if (solution.taskId === this.currentTaskId) {
                        this.solutionId = solution.solutionId;
                        break;
                    }
                }
            }
        },
        'challengeGroupRequest.loaded': function () {
            if (this.challengeGroupRequest.loaded && !this.challengeGroupRequest.error) {
                this.challengeGroupData = this.challengeGroupRequest.apiData;

                this.selectedChallengeId = this.getInitialChallengeId();

                this.$nextTick(() => {
                    this.initializeSlider();
                });
            }
        },
        'selectedChallengeId': function () {
            if (this.siemaSlider) {
                this.siemaSlider.goTo(this.selectedTechnologyIndex);
            }

            let query = {
                technology: this.getTechnologyQuery(this.selectedTechnology),
            }

            for (const [key, value] of Object.entries(this.$route.query)) {
                if (key !== 'technology') {
                    query[key] = value;
                }
            }

            if (this.includeDeactivated) {
                query.includeDeactivated = "true"
            }
            this.$router.push({query: query}).catch(error => {
            });
            this.getChallengeDetails();
        },
        'campaignRequest.loaded': function () {
            this.notBlockedTaskIdsForRTC = [];
            if (!this.campaignRequest.loaded || this.campaignRequest.error) {
                return;
            }
            this.getSponsoringInformationDetails();

            if (this.campaignRequest.challenge_data.nextTaskId) {
                this.setTask(this.campaignRequest.challenge_data.nextTaskId);
            } else if (this.selectedTaskId) {
                this.$nextTick(() => this.setTask(this.selectedTaskId));
            } else {
                this.setTaskIdWithIndex(0);
            }
            // When it's possible to submit a challenge, do it!
            if (this.campaignRequest.challenge_data.actions.hasOwnProperty("submit")) {
                this.receiveRewardDialogVisible = true;
            }
            if (this.campaignRequest.loaded && !this.campaignRequest.error) {
                for (let task of this.campaignRequest.challenge_data.tasks) {
                    if (!window.BLOCKED_TASK_IDS_FOR_RANK_THE_CODE.includes(task.task_id)) {
                        this.notBlockedTaskIdsForRTC.push(task.task_id);
                    }
                }
            }
        },
        'acceptChallengeRequest.loaded': function () {
            if (!this.acceptChallengeRequest.loaded || this.acceptChallengeRequest.error !== null) {
                return;
            }

            if (!isEmpty(services.googleAnalytics)) {
                services.googleAnalytics.sendEvent('Challenge', 'accept', this.campaignRequest.challenge_data.id);
            }

            eventBus.$emit("challenge-accepted");

            // start challenge or show mobile dialog
            if (this.isMobile()) {
                this.onMobileModalVisible = true;
                return;
            }
            this.jumpToNextTask();
        },
    },
    computed: {
        selectedTechnology: function () {
            let challengeGroupTechnology = this.challengeGroupTechnologies[this.selectedTechnologyIndex];
            if (!challengeGroupTechnology) {
                return "";
            }
            return challengeGroupTechnology;
        },
        selectedTechnologyIndex: function () {
            let selectedIndex = 0;

            this.challengeGroupTechnologies.forEach((technology, index) => {
                if (technology.challengeId === this.selectedChallengeId) {
                    selectedIndex = index;
                }
            });
            return selectedIndex;
        },
        isSponsored: function () {
            if (this.sponsoringInformationDetailsRequest.loaded && !this.sponsoringInformationDetailsRequest.error) {
                return this.sponsoringInformationDetailsRequest.apiData.type === "SPONSORED"
            }
            return false;
        },
        isPool: function () {
            if (this.sponsoringInformationDetailsRequest.loaded && !this.sponsoringInformationDetailsRequest.error) {
                return this.sponsoringInformationDetailsRequest.apiData.type === "POOL"
            }
            return false;
        },
        userId: function () {
            if (services.auth.getIDTokenPayload()) {
                return services.auth.getIDTokenPayload().sub;
            }
            return "";
        },
        region: function () {
            if (!this.userProfileRequest.loaded) {
                return;
            }
            if (this.userProfileRequest.error) {
                return;
            }

            return this.userProfileRequest.user_profile.encoded_region;
        },
        profession: function () {
            if (!this.userProfileRequest.loaded) {
                return;
            }
            if (this.userProfileRequest.error) {
                return;
            }

            return this.userProfileRequest.user_profile.profession;
        },
        anonymizedName: function () {
            if (!this.userProfileRequest.loaded) {
                return;
            }
            if (this.userProfileRequest.error) {
                return;
            }
            return this.userProfileRequest.user_profile.anonymizedName;
        },
        isAcceptedAsSponsored: function () {
            if (this.campaignRequest.loaded && !this.campaignRequest.error) {
                let selectedReward = this.campaignRequest.challenge_data.selectedReward;
                return selectedReward === "WITH_SPONSORING" || selectedReward === "WITH_SPONSORING_AFTER_CONTACT"
            }
            return false;
        },
        challengeGroupTechnologies: function () {
            const technologies = [];
            if (this.challengeGroupRequest.loaded && !this.challengeGroupRequest.error) {
                this.challengeGroupData.challenges.forEach(challenge => {
                    if (!this.includeDeactivated && challenge.isDeactivated) {
                        return;
                    }
                    technologies.push(
                        {
                            "challengeId": challenge.id,
                            "id": challenge.technology.id,
                            "name": challenge.technology.name,
                            "language": challenge.technology.language,
                            "isAccepted": challenge.isAccepted,
                            "isSolved": challenge.isSolved,
                        }
                    )
                });
            }
            return technologies;
        },
        rewardAmount: function () {
            if (this.campaignRequest.loaded && !this.campaignRequest.error) {
                if (this.campaignRequest.challenge_data.selectedReward !== null) {
                    return this.campaignRequest.challenge_data.selectedRewardAmount
                        || this.campaignRequest.challenge_data.rewardDefault;  // This is only fallback if the new API data are not present.
                }
                if (this.campaignRequest.challenge_data.selectedReward === null && this.isSponsored) {
                    return this.sponsoringInformationDetailsRequest.apiData.reward
                }
                if (this.campaignRequest.challenge_data.selectedReward === null && this.isPool) {
                    return this.campaignRequest.challenge_data.rewardInteract;
                }
                return this.campaignRequest.challenge_data.rewardDefault;
            }
            return 0;
        },
        isChallengeOftheWeek: function () {
            if (this.campaignRequest.loaded && !this.campaignRequest.error) {
                return this.$features.CHALLENGE_OF_THE_WEEK === this.challengeGroupData.id;
            }
            return false;
        },
        ...mapState([
            'isAuthenticated',
            'isWhitelabelMode'
        ])
    },
    methods: {
        getNiceTime(timestamp) {
            moment.locale("de");
            let dateString = moment(timestamp).format("DD.MM.YY");
            return dateString;
        },
        renderMermaid() {
            mermaid.contentLoaded();
        },
        setUserHasSolvedThisChallenge(value) {
            this.userHasSolvedThisChallenge = value;
        },
        highlightCodeComment(comment) {

            this.$refs.extendedSolutionEditorComponent.highlightComment(comment);
            this.$refs.extendedSolutionEditorComponent.centerEditorFocus(comment);
        },
        removeHighlightCodeComment(commentsWithUserData) {
            this.$refs.extendedSolutionEditorComponent.renderComments(commentsWithUserData);
        },
        setView(view) {
            this.view = view;
            mermaid.contentLoaded();
        },
        getTechnologyDisplayNameShort: function (technology) {
            let programmingLanguage = technology.language.toLocaleLowerCase();
            if (programmingLanguage === "") {
                return this.name;
            }
            if (technology.name === "") {
                return LANGUAGES[programmingLanguage];
            }
            return technology.name;
        },
        getTechnologyDisplayNameJustLanguage: function (technology) {
            let programmingLanguage = technology.language.toLocaleLowerCase();
            if (programmingLanguage === "") {
                return null;
            }
            return LANGUAGES[programmingLanguage];
        },
        getTechnologyDisplayNameJustTechnology: function (technology) {
            if (technology.name === "") {
                return null;
            }
            return technology.name;
        },
        setSelectedChallengeId(index) {
            if (index <= -1) {
                index = this.challengeGroupTechnologies.length - 1;
            }
            if (index >= this.challengeGroupTechnologies.length) {
                index = 0
            }
            this.selectedChallengeId = this.challengeGroupTechnologies[index].challengeId;
        },
        initializeSlider: function () {
            this.siemaSlider = new Siema({
                selector: this.$refs.languageSlider,
                duration: 200,
                easing: 'ease-out',
                perPage: 1,
                startIndex: this.selectedTechnologyIndex,
                draggable: true,
                multipleDrag: false, //true oder?
                loop: true,
                rtl: false,
                onChange: () => {
                    this.setSelectedChallengeId(this.siemaSlider.currentSlide);
                },
                threshold: 100,
            });


            // TODO: find a possibility to listen to resize event of sidebar instead of use timeout to trigger window resize event
            eventBus.$on("sideBarToggle", function () {
                setTimeout(function () {
                    window.dispatchEvent(new Event("resize"))
                }, 500)
            });
        },
        forceRerender() {
            this.submissionsComponentKey += 1;
        },
        getStageByTaskId: function (taskId) {
            if (this.campaignRequest.loaded && !this.campaignRequest.error) {
                for (let task of this.campaignRequest.challenge_data.tasks) {
                    if (task.task_id === taskId) {
                        return task;
                    }
                }
            }
        },
        showUserCoinsOverlay() {
            if (this.$refs.userCoinsOverlay) {
                this.$refs.userCoinsOverlay.$el.style.display = "block";
            }
        },
        jumpToNextTask() {
            let nextTaskId = this.campaignRequest.challenge_data.nextTaskId;
            if (!nextTaskId) {
                nextTaskId = this.campaignRequest.challenge_data.tasks[0].task_id;
            }
            this.$router.push({
                name: 'challenge-edit-view',
                params: {
                    challengeId: this.campaignRequest.challenge_data.id,
                    taskId: nextTaskId
                }
            })
        },
        buttonAction: function (actionUrl, buttonLabel) {
            if (buttonLabel === "login") {
                this.logInAndComeHereAgain();
            }


            if (buttonLabel === "start") {
                if (this.isMobile()) {
                    this.onMobileModalVisible = true;
                    return;
                }
                this.jumpToNextTask()
            }
        },
        logInAndComeHereAgain: function () {
            services.auth.login({fullPath: this.$route.fullPath});
        },
        acceptCampaign: function () {
            let sponsoringOption = this.sponsoringInformationDetailsRequest.apiData.type === 'POOL' ? "WITHOUT_SPONSORING_AFTER_CONTACT" : "WITH_SPONSORING";
            let userUuid = this.userProfileRequest.user_profile.uuid;
            this.acceptChallengeRequest = services.taskManagementService.accceptChallenge(this.campaignRequest.challenge_data.id, sponsoringOption, userUuid);
        },
        setTask: function (taskId) {
            this.currentTaskId = taskId;
            this.flowRequest = services.flowService.getFlowContent(taskId);
            if (this.isAuthenticated) {
                this.testStatusRequest = services.flowService.getTestStatus(taskId);
            }
        },
        setTaskIdWithIndex(index_in_list) {
            let task = this.campaignRequest.challenge_data.tasks[index_in_list];
            this.setTask(task.task_id);
        },
        progress: function () {
            if (!this.successfulScenarios && !this.failedScenarios) {
                let count = this.successfulScenarios.length + this.failedScenarios.length;
                if (count === 0) {
                    return 0;
                }
                return this.successfulScenarios.length / count * 100;
            }
            return 0;
        },
        scenarioJumpLink: (stage, index) => "stage-" + stage.index + "-scenario-" + index,
        inList: function inList(myList, item) {
            if (typeof myList === "undefined" || typeof item === "undefined") {
                return false;
            }

            for (let index = 0; index < myList.length; ++index) {
                let i = myList[index];
                if (i.scenario_id === item.id) {
                    return true;
                }
            }
            return false;
        },
        closeOnMobileModal() {
            this.onMobileModalVisible = false
        },
        closeReceiveRewardDialog() {
            this.receiveRewardDialogVisible = false;

            this.showUserCoinsOverlay();
            this.getChallengeDetails();
            eventBus.$emit('user-coins-changed');
            this.forceRerender();
        },
        isMobile: function () {
            return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        getSponsoringInformationDetails() {
            this.sponsoringInformationDetailsRequest = services.companyService.getSponsoringInformationDetails(
                this.campaignRequest.challenge_data.id, true
            );
        },
        updateVersionCode(index) {
            this.currentVersionCode = this.versions[index].content;
            let previousVersionIndex = index - this.step;
            if (previousVersionIndex < 0) {
                previousVersionIndex = 0;
            }
            this.previousVersionCode = this.versions[previousVersionIndex].content;
        },
        playHistory() {
            if (this.isPlaying) {
                return this.stopHistory();
            }

            let versionIndex = parseInt(this.versionIndex);
            if (versionIndex === this.versions.length - 1) {
                this.versionIndex = 0;
            }

            let play = function () {
                if (!this.isPlaying) {
                    return;
                }
                let versionIndex = parseInt(this.versionIndex) + this.step;
                if (versionIndex >= this.versions.length) {
                    this.isPlaying = false;
                    return;
                }
                this.versionIndex = versionIndex;
                setTimeout(play.bind(this), this.speed);
            };
            this.isPlaying = true;
            setTimeout(play.bind(this), this.speed);
        },
        stopHistory() {
            this.isPlaying = false;
        },
        forwardHistory() {
            this.versionIndex = this.versions.length - 1;
        },
        backwardHistory() {
            this.versionIndex = 0;
        },
        increaseSpeed() {
            let speed = Math.floor(this.speed / 2);
            if (speed < 25) {
                return;
            }
            this.speed = speed;
        },
        decreaseSpeed() {
            let speed = Math.floor(this.speed * 2);
            if (speed >= 1000) {
                return;
            }
            this.speed = speed;
        },
        getChallengeDetails() {
            let region = "";
            this.notBlockedTaskIdsForRTC = [];
            this.campaignRequest = services.taskManagementService.getChallengeDetails(
                this.selectedChallengeId,
                region
            );
        },
        getChallengeGroupDetails() {
            this.challengeGroupRequest = services.taskManagementService.getChallengeGroupDetails(this.$route.params.slug);
        },
        getInitialChallengeId() {
            let technologyQuery = this.$route.query.technology;
            if (technologyQuery) {
                let challengeId = this.getChallengeIdByTechnologyQuery(technologyQuery);
                if (challengeId) {
                    return challengeId;
                }
            }
            return this.challengeGroupTechnologies[0].challengeId;

        },
        getChallengeIdByTechnologyQuery(technologyQuery) {
            let challengeId = "";
            let tokens = technologyQuery.split("+");
            if (tokens.length > 1) {
                tokens[1] = tokens[1].replace(/\s/g, "");
            }
            const searchString = tokens.join("").toLowerCase();
            this.challengeGroupTechnologies.forEach(technology => {
                let technologyString = technology.language.toLowerCase() + technology.name.replace(/\s/g, "").toLowerCase();
                if (technologyString === searchString) {
                    challengeId = technology.challengeId;
                }
            });
            return challengeId;
        },
        getTechnologyQuery: getTechnologyQuery,
        getLanguageBubbleCSS(selectedTechnology) {
            return {
                'bg-python': selectedTechnology.language.toLocaleLowerCase() === 'python',
                'bg-dockerfile': selectedTechnology.language.toLocaleLowerCase() === 'docker',
                'bg-java': selectedTechnology.language.toLocaleLowerCase() === 'java',
                'bg-javascript': selectedTechnology.language.toLocaleLowerCase() === 'javascript',
                'bg-csharp': selectedTechnology.language.toLocaleLowerCase() === 'csharp',
                'bg-cpp': selectedTechnology.language.toLocaleLowerCase() === 'cpp',
                'bg-php': selectedTechnology.language.toLocaleLowerCase() === 'php',
                'bg-abap': selectedTechnology.language.toLocaleLowerCase() === 'abap',
                'bg-kotlin': selectedTechnology.language.toLocaleLowerCase() === 'kotlin',
                'bg-powershell': selectedTechnology.language.toLocaleLowerCase() === 'powershell',
                'bg-rust': selectedTechnology.language.toLocaleLowerCase() === 'rust',
            }
        }
    },
    created() {
        window.onresize = () => {
            clearTimeout(this.forceRerenderSiemaSliderTimeout);
            this.forceRerenderSiemaSliderTimeout = setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
            }, 500);
        };
        this.getChallengeGroupDetails();

        if (this.isAuthenticated) {
            this.userProfileRequest = services.userService.getUserProfile();
        }
        eventBus.$on('user-profile-changed', () => {
            this.userProfileRequest = {loaded: false, error: null};
            this.userProfileRequest = services.userService.getUserProfile();
        });
        eventBus.$on('show-other-solution', (data) => {
            // only react to event when view is not otherSolutions
            // otherwise other solution list already reacts
            if (this.view !== 'otherSolutions') {
                this.setView('otherSolutions');
                this.selectedTaskId = data.taskId;
                let query = Object.assign({}, this.$route.query);
                query.solutionId = data.solutionId;
                // dirty hack to add query params from url, so we catch the error linking to the same site
                this.$router.replace({query}).catch(() => {
                });
                this.$nextTick(() => {
                    this.setTask(this.selectedTaskId);
                });
            }
        });
    },
    mounted() {
        let query = Object.assign({}, this.$route.query);
        delete query.view;
        delete query.taskId;
        if (this.view !== 'otherSolutions') {
            delete query.solutionId;
        }

        // dirty hack to remove query params from url, so we catch the error linking to the same site
        this.$router.replace({query}).catch(() => {
        });
    },
    updated() {
        this.$nextTick(function () {
            let tooltips = $('[data-toggle="tooltip"]');
            tooltips.tooltip('destroy');
            tooltips.tooltip();
            this.renderMermaid();
        })
    },
    beforeDestroy() {
        // don't remove 'sideBarToggle' and 'user-profile-changed',
        // because other components still need it
        eventBus.$off('show-other-solution');
    },
}
</script>


<style scoped>
.link {
    color: #08AB99;
}

.no-border {
    border: 0 !important;
}

.flow {
    margin-top: 0;
    padding-top: 5.5rem;
    margin-bottom: 110px; /* to ensure that the Action-Bar does not overlap with the flow-content*/
}

.flow-background {
    background: white;
}

.flow-body {
    margin-bottom: 3rem;
    font-size: 107%;
}

.scenario-description {
    margin-top: 0.5rem;
}

.challenge-tasks {
    margin-top: 2.5rem;
}

.reward-svg-box {
    background: #F2F7FD;
    height: 100%;
    width: 50px;
    border-radius: 4px 0 0 4px;
    float: left;
}


.sponsored-icon {
    height: 100%;
    padding: 7px;
}

.not-sponsored-icon {
    height: 100%;
    padding: 7px;
    display: inline-block;
}

.coins-icon {
    height: 2.5rem;
    margin-top: -5px;
}

.coins-icon-paragraph {
    display: inline-block;
    float: right;
    line-height: 50px;
    font-size: 2.5rem;
    margin-right: 1rem;
    color: #606060;
}

.reward-sponsored {
    color: rgba(158, 158, 158, 0.8);
    font-size: 1em;
    font-weight: lighter
}

.challenge-description-detail {
    margin-bottom: 2rem;
    color: white;
    font-size: 109%;
}

.summary {
    padding: 0 0 10px 0;
    margin: 0 0;
    text-transform: uppercase;
    font-weight: bolder;
    color: white;
}

.loader.visible {
    display: block;
}

.loader {
    margin-top: 5rem;
    margin-bottom: 5rem;
    opacity: 1;
    width: 100%;
    display: none;
}

.loader p {
    text-align: center;
}

.campaign-detail-flow-scenarios .scenario-hr {
    margin-bottom: 18px;
}

.campaign-detail-flow-scenarios sentence {
    display: block;
    padding: 5px;
}

.scenario-hr {
    margin-bottom: 0px;
}

.campaign-detail-flow-scenarios .scenario-body {
    padding-top: 0;
}

.progressbar {
    counter-reset: step;
    padding: 4rem 0rem;
    margin: 0rem;
    margin-top: 3rem;
}

.progressbar li {
    list-style-type: none;
    float: left;
    font-size: 12px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: #7d7d7d;
}

.progressbar li:hover::before {
    -webkit-box-shadow: 0 8px 24px rgba(13, 51, 85, 0.2);
    -moz-box-shadow: 0 8px 24px rgba(13, 51, 85, 0.2);
    box-shadow: 0 8px 24px rgba(13, 51, 85, 0.2);
}

.progressbar li:before {
    width: 35px;
    height: 35px;
    content: "";
    counter-increment: step;
    line-height: 30px;
    border: 3px solid #C5DEF7;
    display: block;
    text-align: center;
    margin: 0 auto 10px auto;
    border-radius: 50%;
    background-color: white;
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    font-weight: lighter;
    font-size: 2rem;
    transition: all 0.1s ease-out;
    color: #2c3e50;
}

.progressbar li:after {
    width: 100%;
    height: 5px;
    content: '';
    position: absolute;
    background-color: #C5DEF7;
    top: 15px;
    left: -50%;
    z-index: -1;
}

.progressbar li:first-child:after {
    content: none;
}

.progressbar li:active::before {

}

.progressbar li.active::before {
    height: 50px !important;
    width: 50px !important;;
    line-height: 45px !important;;
    transform: translateY(-7px) !important;;
}

.progressbar li.solved {
    border-color: #08AB99;
}

.progressbar li:hover::before {
    font-weight: 100;
    height: 40px;
    width: 40px;
    line-height: 35px;
    transform: translateY(-2px);

}

.progressbar li.solved:before {
    border-color: #0BC4A2 !important;
    color: #0BC4A2;
    background-color: white;
    font-family: FontAwesome;
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    content: "\f00c";
}

.progressbar li.solved + li:after {
    background: linear-gradient(to bottom right, #08AB99 0%, #0BC4A2 100%);
}

.nav-stages li:hover {
    cursor: pointer;
}

.nav-stages li.active a {
    color: #061a2d;
    border: none;
    font-weight: bolder;
    background-color: transparent;
}

.nav-tabs.nav-stages > li.active > a:before {
    border-top: none;
}

.nav-tabs.nav-stages > li.active > a:hover {
    cursor: pointer;
    background-color: whitesmoke;
    border: none;
}

.reward-panel {
    width: 100%;
    margin-top: 3rem;
    padding: 15px 0 20px 0;
    color: white;
}

.reward-box-container {
    float: left;
    margin-right: 3rem;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.reward-box:hover {
    box-shadow: 0 10px 30px rgba(50, 50, 93, .1), 0 5px 10px rgba(0, 0, 0, .37);
    transform: translateY(-1px);
}

.reward-box {
    height: 50px;
    background: linear-gradient(135deg, white, #f6f8fa);
    border-radius: 4px;
    box-shadow: 0 10px 30px rgba(50, 50, 93, .1), 0 5px 10px rgba(0, 0, 0, .02);
    transition: all 0.1s ease-out;
    cursor: default;
    width: 225px;
}

.rewardChosen .reward-box-container {
    border: none;
    width: 100%;
}

.reward-box-container.company-service-down {
    width: 100%;
    border-right: none;
}

@keyframes cssAnimation {
    to {
        width: 0;
        height: 0;
        overflow: hidden;
    }
}

@-webkit-keyframes cssAnimation {
    to {
        width: 0;
        height: 0;
        visibility: hidden;
    }
}

.slider-wrapper input {
    width: 100%;
    margin-top: 0.5em;
}


.hard-mode-background-color {
    background-color: #d35400;
}

.user-submission-state-panel {
    border: none;
    background: linear-gradient(90deg, #EDF5FC, #F2F7FD);
    box-shadow: none;
}

.flow-col >>> sentence {
    display: block !important;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 2rem;
    padding-right: 2rem;

}

.flow-col >>> sentence:nth-child(odd) {
    background-color: var(--sentence-second-background);
}


.challenge-details {
    background: linear-gradient(to bottom right, #08AB99 0%, #0BC4A2 100%);
    padding: 5rem 1rem;
    overflow: hidden;
    position: relative;
    margin: 0 10px 6rem;
}

@media (max-width: 991px) {
    .challenge-details {
        margin: 0 5px 6rem;
    }
}

.task-heading {
    margin-bottom: 5rem;
    text-transform: uppercase;
    font-weight: bolder;
    color: #53b49a;
}

.start-challenge-panel {
    position: fixed;
    bottom: 0;
    height: 100px;
    width: 100%;
    margin: 0;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(10px);
    z-index: 3;
    border-radius: 0 !important;
}

.action-button-wrapper {
    display: flex;
    position: relative;
}

.action-button-wrapper .btn-big-cta {

    font-size: 2rem;
    text-transform: uppercase;
    color: white;
    border: none;
    padding: 1.75rem;
    margin-right: 2rem;
    border-radius: 13px;
    vertical-align: middle;
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    -webkit-transition-property: color;
    transition-property: color;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    z-index: 1;
}

.button-background {
    background: rgba(129, 163, 204, 0.09);
    padding: 0.75rem;
    border-radius: 18px;
    margin: 0.75rem 2.5rem 0.75rem 2rem;
}

.language-label {
    text-align: center;
    display: inline-block;
    font-size: 1.75rem;
    padding: 1.75rem 1.75rem 1.75rem 0;
    vertical-align: middle;
    font-weight: 600;
    color: #0D3359;
}

.technology-label {
    font-size: 1rem;
    color: #08AB99;
    text-align: center;
    line-height: 1;
}

.button-submit, .button-login {
    margin: 2rem;
    font-size: 2rem;
}

.contact-information {
    width: inherit;
    height: inherit;
    padding: 12px;
}

.new-editor-label {
    line-height: 10px;
    padding: 1rem 2rem;
    border-radius: 10px;
    margin: 0 auto;
    background-color: #2b86c5;
    background-image: linear-gradient(19deg, #2b86c5 0%, #B721FF 100%);
    font-weight: 600;
    box-shadow: 0 0 0 0 rgba(43, 134, 197, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
    display: inline-block;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(43, 134, 197, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(43, 134, 197, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(43, 134, 197, 0);
    }
}

.new-editor {
    color: white;
    font-size: 1.4rem;
    width: 100%;
    vertical-align: middle;
}

@media (max-width: 415px) {
    .challenge-details {
        padding: 2rem .5rem;

    }

    .action-button-wrapper button {
        font-size: 1.5rem;
        padding: 1rem;
    }

    .start-challenge-panel {
        height: 80px;
    }

    .language-label {
        font-size: 1.25rem;
        padding: 0 1.75rem 0 0;
    }

    .button-background {
        margin-left: 2rem;
        padding: 0;
    }

    .button-submit, .button-login {
        margin-top: 1.5rem;
        font-size: 2rem !important;
    }
}

.page-header {
    font-weight: 700;
    margin-bottom: 24px;
    padding-left: 9px;
}

.challenge-icon img {
    margin-left: 0.1rem;
    max-height: 35px;
    padding-bottom: 0.7rem;
    margin-bottom: 0.2rem;
    margin-right: 0.8rem;
    line-height: 1.5;
}

.bg-object-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url('/assets/img/challenge_detail_background.svg');
    background-position: right;
    background-size: cover;
    margin-left: -23%;
}

.tab-container {
    padding: 0 1rem;
    min-height: calc(100vh - 250px);
}

.nav {
    margin-left: 1rem;
}

.flex {
    display: flex;
    flex-direction: row;
    align-items: center;
}


.statistics-row {
    padding: 2.5rem;
    background: linear-gradient(90deg, #EDF5FC, #F2F7FD);
    border-radius: 10px;
    margin: 1rem 0 10rem;
}

.solution-row {
    padding: 4rem 4rem;
    background: linear-gradient(90deg, #EDF5FC, #F2F7FD);
    border-radius: 10px;
    margin: 1rem 0 1rem;
}

.date-solved-container {
    height: 8rem;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-sizing: border-box;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
}

.icon-container {
    height: 8rem;
    width: 8rem;
    background: repeating-linear-gradient(#E4F0FB 0%, #CEE3F8 100%);
    border-radius: 10px 0 0 10px;
    position: relative;
    float: left;
}

.icon-container:before {
    content: "\f00c";
    font: normal normal normal 14px/1 FontAwesome;
    color: whitesmoke;
    display: block;
    width: 5rem;
    height: 5rem;
    line-height: 5rem;
    border-radius: 50%;
    background: linear-gradient(to bottom right, #08AB99 0%, #0BC4A2 100%);
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    box-shadow: 0 2px 4px rgba(173, 181, 189, 0.15);
    font-size: 2rem;
    text-align: center;
}

.date-text {
    padding: 1.3rem;
    height: 8rem;
    float: left;
    width: calc(100% - 8rem);
    display: flex;
    align-items: center;
}

.date-container {
    padding-left: 1rem;

}

.date {
    font-size: 1.6rem;
    font-weight: bold;
}

.dropdown-container {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    justify-content: end;
    font-family: "Source Code Pro", sans-serif;
}

.tabs-container {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    font-family: "Source Code Pro", sans-serif;
}

.tabs {
    display: flex;
    position: relative;
    background-color: #fff;
    box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
    border-radius: 99px;
    padding: 0.75rem 0.75rem 1.5rem;

}

.tabs * {
    z-index: 5;
}

input[type="radio"] {
    display: none;
}

.tab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    font-size: 1.5rem;
    font-weight: 500;
    border-radius: 99px;
    border-collapse: separate;
    cursor: pointer;
    transition: color 0.15s ease-in;
    padding-top: 0.5rem;
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
    line-height: 2;
    height: 10px;
    letter-spacing: 0.05rem;
    margin-top: 1rem;
}

.tabs input[type="radio"]:checked + label {
    color: white;
    transition: color 0.5s ease-in;
}

.challenge-state-icon {
    font-size: 1.4rem;
    margin-right: 1rem;
}

.glider {
    position: absolute;
    display: flex;
    height: 32px;
    width: 150px;
    background-color: #08AB99;
    transition: all 0.5s ease-out;
    z-index: 1;
    border-radius: 99px;
}

@media (max-width: 700px) {
    .tabs {
        transform: scale(0.6);
    }
}

.lang-selector {
    padding-bottom: 2rem;
    padding-left: 2rem;
    padding-right: 25px;
}

.lang-icon path {
    fill: #6dac5f !important;
}

.lang-icon-wrapper > p {
    margin-bottom: 0;
    color: #08AB99;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
}

@media (max-width: 1200px) {
    .lang-selector {
        text-align: center !important;
    }
}


input[type="radio"]:checked + {
    color: white;
    background-color: #08AB99;
    border-radius: 99px;

}

.challenge-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.challenge-title > * {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 300px;
}

@media (max-width: 700px) {
    .tabs {
        transform: scale(0.6);
    }

    .sponsor-container {
        margin-top: 2rem;
    }
}

@media (max-width: 1439px) {
    .lang-selector {
        margin-top: 0;
    }
}

.siema {
    margin-bottom: 2rem;
}

.language-slider-tab {
    font-size: 18px;
    letter-spacing: 0.05rem;
    font-weight: 500;
    border-radius: 99px;
    transition: color 0.15s ease-in;
}

.language-item {
    padding: 1rem;
    border-radius: 99px;
    color: white;
}

.language-slider-container {
    width: 100%;
    background: #fff;
    border-radius: 99px;
    box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
    position: relative;
    font-family: "Source Code Pro", sans-serif;
}

.nav-icon {
    display: flex;
    position: absolute;
    top: calc(50% - 0.6rem);
    cursor: pointer;
    z-index: 6;
    color: grey;
}

.nav-prev {
    left: 0.8rem;
}

.nav-next {
    right: 0.8rem;
}

.active-background {
    background-color: #08AB99;
    width: 86%;
    position: absolute;
    height: 86%;
    top: 7.4%;
    border-radius: 99px;
    left: 7%;
}

.difficulty-level img {
    max-width: 40px;
    margin-bottom: 0.2rem;
    margin-right: 0.8rem;
    margin-left: 0.5rem;
}

.dots {
    text-align: center;
    margin-top: -1rem;
    margin-bottom: 1rem;
}

.dot {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0 3px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
}

.active-dot, .dot:hover {
    background-color: #08AB99;
}

.nav-stages li a:hover {
    background-color: unset !important;
}

@media (min-width: 1200px) {
    .sponsor-wrapper {
        max-width: 500px;
    }
}

@media (min-width: 992px) {
    .solution-col {
        padding-right: 0;
    }
}

.icon {
    height: 3rem;
    margin-right: 2rem;
}

.stage-tabs {
    margin-left: 1.5rem;
}

@media (max-width: 768px) {
    .sponsor-container {
        margin-top: 2rem;
    }

    .challenge-details {
        margin: 0;
    }

    .page-header {
        padding-left: 0;
    }

    .nav-tabs > li > a {
        padding: 1rem;
        margin: 3rem 1rem 0 0;
    }

    .nav {
        margin-left: 0;
    }

    .tab-container {
        padding: 0;
    }

    .statistics-row, .statistics-container {
        padding: 0 !important;
    }

    .solution-col, .flow-col {
        clear: both;
    }

    .solution-row {
        padding: 1.5rem;
    }

    .stage-tabs {
        margin-left: 1.5rem;
    }
}

.whitelabel-challenge-container {
    @media (min-width: 1400px) {
        width: 1400px;
        margin: 0 auto;
    }
}

.whitelabel .start-challenge-panel {
    left: 0;
}

.whitelabel .action-button-wrapper {
    justify-content: center;
}

.solved-whitelabel-challenge {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 2rem;
    font-size: 1.5rem;
    justify-content: center;
}

</style>
